<template>
  <div class="selfcare-menu-container">
    <nav>
      <h3 class="mobile-show">
        {{ $t("bnpl:selfcare.menu") }}
      </h3>
      <ul v-if="loaded">
        <template v-for="(page, pageId) in pages">
          <template v-if="!disallowedPages.includes(pageId)">
            <SelfcareMenuItem
              v-if="showMenuItem(page, pageId)"
              :key="pageId"
              :icon="page.icon"
              :title="page.name"
              :description="page.desc"
              :active="pageId === activePage"
              :is-mobile="isMobile"
              :class="{ active: pageId === activePage }"
              @click="navigateToPage(pageId)"
            />
          </template>
        </template>
      </ul>
    </nav>
    <footer>
      <div class="flex-column align-items-end">
        <template
          v-if="config.public.bnplInstanceType === BNPL_INSTANCE_TYPE.FACTORING"
        >
          <div class="poweredBy">powered by</div>
          <div class="instaCash">mil<span class="cash">pay</span></div>
        </template>
        <template
          v-if="
            config.public.bnplInstanceType ===
            BNPL_INSTANCE_TYPE.MERCHANT_FINANCE
          "
        >
          <div class="poweredBy">powered by</div>
          <div class="instaCash">insta<span class="cash">cash</span></div>
        </template>
      </div>
    </footer>
  </div>
</template>

<script setup>
// import Settings from "@/components/icons/Settings.vue";
// import ShoppingBasket from "@/components/icons/ShoppingBasket.vue";
// import Menu2 from "@/components/icons/Menu2.vue";
// import User from "@/components/icons/User.vue";
// import Help from "@/components/icons/Help.vue";

import { useSelfcareStore } from "~~/stores/selfcare";
// import { useSessionStore } from "~/stores/session";
import { useLimitStore } from "~~/stores/limit";
import { useReferralStore } from "~~/stores/referral";
import { useCustomerLimitStore } from "~~/stores/customerLimit";

defineProps({
  isMobile: {
    type: Boolean,
    default: false,
  },
});

const config = useRuntimeConfig();

// const sessionStore = useSessionStore();
const selfcareStore = useSelfcareStore();
const limitStore = useLimitStore();
const referralStore = useReferralStore();
const customerLimitStore = useCustomerLimitStore();

const route = useRoute();

const emit = defineEmits(["click"]);

// const icons = { Settings, ShoppingBasket, Menu2, User, Help };

const pages = computed(() => selfcareStore.pages);
const activePage = computed(
  () => selfcareStore.activePage?.toLowerCase() ?? ""
);

const disallowedPages = ref([]);
const loaded = ref(false);

function showMenuItem(page, pageId) {
  if (!page.showInMenu) return false;
  if (["rewards", "coupon"].includes(pageId)) {
    return referralStore.hasBeenIncluded;
  }
  if (pageId === "customer-limit") {
    return customerLimitStore.isCustomerLimitEnabled;
  }
  if (pageId === "limit") {
    return !customerLimitStore.isCustomerLimitEnabled;
  }
  return true;
}

onBeforeMount(async () => {
  const hasLiveLimits =
    limitStore.hasLiveLimitsValue ?? (await limitStore.hasLiveLimits());

  if (!hasLiveLimits) {
    disallowedPages.value.push("limit");
  }

  await referralStore.fetchHasBeenIncluded(route.params.financier);
  await referralStore.fetchIsIncluded(route.params.financier);
  loaded.value = true;
});

const navigateToPage = async (pageId) => {
  if (selfcareStore.activePage !== pageId) {
    selfcareStore.navigateTo(pageId);
  }
  emit("click");
};
</script>

<style scoped lang="scss">
.selfcare-menu-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;

  nav {
    display: flex;
    flex-direction: column;
    // flex: 1;
    flex-grow: 0;
    height: calc(100% - 45px);
    max-height: calc(100% - 45px);
    // box-sizing: border-box;

    ul {
      position: relative;
      list-style-type: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 16px;
      height: 100%;
      max-height: 100%;
      overflow: auto;
      // Without this, a swipe past the top/bottom edge of this list chains into
      // whatever's scrollable behind the (fixed, but unlocked) menu overlay.
      overscroll-behavior: contain;
    }
  }

  footer {
    // position: relative;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 45px;
  }
}

li {
  padding: 8px;
  border-radius: 8px;

  &::before {
    display: none;
  }

  &.active {
    background: var(--gray50);
  }

  &:hover {
    background: var(--gray50);
    cursor: pointer;
  }

  .icon {
    margin-right: 8px;
    display: flex;
    align-items: center;

    svg {
      display: block;
    }
  }

  .title {
    font-weight: 700;
    margin-bottom: 6px;
  }

  .desc {
    font-size: 10px;
    color: var(--gray600);
  }

  .mobile-show {
    display: none;
  }
}

.mobile-show {
  display: none;
}

h3 {
  color: var(--gray400);
  margin-top: 8px;
  margin-bottom: 24px;
}

// footer {
//   position: absolute;
//   bottom: 0;
// }

.instaCash {
  margin-bottom: 0;
}

@media only screen and (max-width: 792px) {
  .mobile-hide {
    display: none !important;
  }

  .mobile-show {
    display: flex !important;
  }

  ul {
    gap: 24px;
  }

  li {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 16px;

    &:hover,
    &.active {
      background: none;
    }

    .title {
      font-size: 20px;
      margin-bottom: 4px;
    }

    .desc {
      font-size: 14px;
    }

    .icon {
      padding: 16px;
      background: var(--gray50);
      border-radius: 8px;
    }
  }

  // footer {
  //   right: 0;
  //   bottom: 8px;
  // }
}
</style>
